// extracted by mini-css-extract-plugin
export default {"button":"go-to-payment_button__82a1d"};